'use strict'

import { ApiDeleev, ApiUtils } from '../index'

export default {
  login({ email, password }) {
    return ApiUtils.promisePost(ApiDeleev, '/auth/login/', { email, password })
  },
  checkToken(token) {
    if (!token) {
      return new Promise((resolve, reject) => {
        return reject(new Error('Token not found'))
      })
    }

    return ApiUtils.promiseGet(ApiDeleev, '/admin-user/', {
      headers: { Authorization: 'Token ' + token },
    })
  },
  logout() {
    return new Promise((resolve) => {
      // do api logout action
      resolve()
    })
  },
}
